import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { ApiService } from '../services/api.service';
import { DomSanitizer } from '@angular/platform-browser';
import { fileTypeFromBuffer } from 'file-type';

@Component({
	selector: 'app-mail-content',
	templateUrl: './mail-content.component.html',
	styleUrl: './mail-content.component.css',
	encapsulation: ViewEncapsulation.Emulated
})
export class MailContentComponent implements OnInit, AfterViewInit {
	@Input() viewMail: any;
	@Output() mail_html_fetched = new EventEmitter<any>();
	@ViewChild('iframe') iframe!: ElementRef;
	style: any = {
		"width": "100%",
		"height": "100vh"
	};
	fetchingHtml = false;

	constructor(private apiService: ApiService, private sanitizer: DomSanitizer) { }

	ngOnInit(): void { }

	ngAfterViewInit(): void {
		this.getMailBodyOld();
		/* this.getMailBodyNew(); */
	}

	getMailBodyOld() {
		this.writeIframe(this.viewMail.body_html);
	}

	async getMailBodyNew() {
		if (this.viewMail.html_path) {
			this.fetchingHtml = true;
			this.apiService.getMailContent(this.viewMail.html_path).subscribe({
				next: async (data: any) => {
					this.fetchingHtml = false;
					const html = await this.renderEmail(data);
					this.writeIframe(html);
					console.log("%cMail fetched from File", "color: green;");
				}, error: async (error) => {
					this.fetchingHtml = false;
					const html = await this.renderEmail(this.viewMail.body_html);
					this.writeIframe(html);
					console.log("%cMail fetched from DB", "color: red;");
				}
			});
		} else {
			const html = await this.renderEmail(this.viewMail.body_html);
			this.writeIframe(html);
			console.log("%cMail fetched from DB", "color: red;");
		}
	}

	writeIframe(content: any) {
		content = this.replaceBlockquoteWithDiv(content);
		this.viewMail.body_html = content;
		this.mail_html_fetched.emit(this.viewMail);
		let doc = this.iframe.nativeElement.contentDocument || this.iframe.nativeElement.contentWindow;
		if (doc) {
			doc.open();
			doc.write(content);
			doc.close();
		}
	}

	replaceBlockquoteWithDiv(htmlString: string): string {
		const container = document.createElement('div');
		container.innerHTML = htmlString;
		container.querySelectorAll('blockquote').forEach((el) => {
			if (el instanceof HTMLElement) {
				const div = document.createElement('div');
				Array.from(el.attributes).forEach((attr) =>
					div.setAttribute(attr.name, attr.value)
				);
				while (el.firstChild) {
					div.appendChild(el.firstChild);
				}
				el.parentNode?.replaceChild(div, el);
			}
		});
		return container.innerHTML;
	}


	resizeIframe(iframe: any) {
		try {
			var height = iframe.contentWindow.document.documentElement.scrollHeight + 'px';
		} catch (error) {
			var height = "100vh";
		}
		this.style.height = height;
	}

	async renderEmail(html: string) {
		const regex = /<img.*?src="(cid:[^"]+)"[^>]*>/g;
		const matches = [...html.matchAll(regex)];
		for (const match of matches) {
			const cid = match[1];
			const data = await this.apiService.fetchImageForCid(cid);
			if (data.body) {
				const mimeType = this.getMimeTypeFromArrayBuffer(data.body);
				const blob = new Blob([data.body], { type: mimeType || 'image/png' });
				const url = URL.createObjectURL(blob);
				html = html.replace(cid, url);
			}
		}
		return html;
	}

	getMimeTypeFromArrayBuffer(buffer: ArrayBuffer): string | null {
		const arr = new Uint8Array(buffer);
		if (arr.length < 4) return null;
		const sig = arr.slice(0, 4).map((b: any) => b.toString(16).padStart(2, '0')).join('').toUpperCase();
		console.log(sig)
		switch (sig) {
			case '89504E47': return 'image/png';
			case '8950047': return 'image/png';
			case '47494638': return 'image/gif';
			case '25504446': return 'application/pdf';
			case 'FFD8FFDB':
			case 'FFD8FFE0': return 'image/jpeg';
			case '504B0304': return 'application/zip';
			default: return null;
		}
	}
}
